<panel *ngIf="!orders.empty">

  <div header>
    <span media="screen">{{title | lang}}</span>
    <span media="print">总订单</span>
  </div>

  <div right class="flex">
    <button class="bg-success text-white pointer hlf-margin-right" (click)="exportXlsx()"><i class="fa fa-file-excel"></i></button>
    <button class="bg-primary text-white pointer" (click)="print()"><i class="fa fa-print"></i></button>
    <span media="print">{{ now | date : 'dd-MM-yyyy HH:mm:ss z'}} ({{importOrderName}})</span>
  </div>

  <table responsive class="data hover">

    <tr>
      <th class="text-left">
        <span media="screen">{{'Mã hàng' | lang}}</span>
        <span media="print">货号</span>

      </th>
      <th class="text-center">
        <span media="screen">{{'Màu' | lang}}</span>
        <span media="print">颜色</span>
      </th>
      <th class="text-center">
        <span media="screen">{{'Số cây' | lang}}</span>
        <span media="print">匹数</span>
      </th>
      <th class="text-right">
        <span media="screen">{{'Tổng dài / nặng' | lang}}</span>
        <span media="print"></span>
      </th>
      <th class="text-center">
        <span media="screen">{{'Hẹn giao' | lang}}</span>
        <span media="print">交货时间</span>
      </th>
      <th class="text-right">
        <span media="screen">{{'Giá nhập' | lang}}</span>
        <span media="print">价格</span>
      </th>
      <th class="text-right">
        <span media="screen">{{'Giá bán' | lang}}</span>
        <span media="print">越南盾</span>
      </th>
    </tr>


    <ng-container *ngFor="let order of orders.source">

      <tr>
        <td>
          <span media="screen">{{'ĐƠN' | lang}}</span><span media="print">单</span>&nbsp;<b class="spacy text-primary">{{order.Tag}}</b> ({{partner(order).Name}})
        </td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td class="text-right">
          <button *ngIf="!order.Notified" class="bg-primary text-white pointer" (click)="notify(order)"><i class="fa fa-check"></i></button>
        </td>
      </tr>


      <tr *ngFor="let i of order.Details; index as ix">
        <td><good class="bold spacy text-success nowrap" [sku]="i.SKU"></good></td>
        <td class="text-success">{{i.Color}}</td>
        <td><b class="text-primary">{{i.Quantity - i.Provided | number : '1.0-0' : 'en-US'}}</b></td>
        <td>
          <ng-container *ngIf="i.ExpectedUnitQuantity > 0"><b class="text-info">{{i.ExpectedUnitQuantity / i.Quantity * (i.Quantity - i.Provided) | number : '1.0-0' : 'en-US'}}</b><product-unit [type]="i.Unit"></product-unit></ng-container>
          <small class="uppercase" *ngIf="i.ExpectedUnitQuantity == 0">{{'không yêu cầu' | lang}}</small>
        </td>
        <td>
          <ng-container *ngIf="i.ExpectedDelay > 0"><b class="{{className(order, i)}}">{{deadline(order, i) | date : 'dd-MM-yyyy'}}</b></ng-container>
          <small class="uppercase" *ngIf="i.ExpectedDelay == 0">{{'không yêu cầu' | lang}}</small>
        </td>
        <td><b class="text-primary">{{i.ImportUnitPrice | number : '1.0-2' : 'en-US'}}</b><span class="opacity-75 hlf-margin-left">¥/m</span></td>
        <td><b class="text-info">{{i.QuoteUnitPrice | number : '1.0-2' : 'en-US'}}</b><span class="opacity-75 hlf-margin-left">đ/m</span></td>
      </tr>

      <tr>
        <td>
          <small class="bold">
            <span media="screen">{{'TỔNG ĐƠN' | lang}}</span>
            <span media="print">总单</span>
            {{order.Tag}}
          </small>
        </td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td class="small">
          <number [sign]="false" [value]="quantity(order)" [good]="'none'"></number>
          <unit media="screen">{{'cây' | lang}}</unit>
          <unit media="print">匹</unit>
        </td>
      </tr>

    </ng-container>

    <tr class="footer">
      <td class="bold">
        <span media="screen">{{'TỔNG CỘNG' | lang}}</span>
        <span media="print">总共</span>
      </td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td class="bold">
        <number [sign]="false" [value]="totalQuantity" [good]="'none'"></number>
        <unit media="screen">{{'cây' | lang}}</unit>
        <unit media="print">匹</unit>
      </td>
    </tr>

  </table>

</panel>

<div class="w-100" *ngIf="!loading && orders.empty"><button class="text-white bg-success std-margin" style="float: right" (click)="synchronize()"><i class="fa fa-sync"></i></button></div>
<ngx-loading [show]="loading"></ngx-loading>

